import React from 'react';
import Avatar from 'react-avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/system';
import Text from '../Text.js';
import { colors } from '../../theme/index.js';

/**
 * 
 * @param {*} param0 
 */
const MasterMetaMenu = ({
  open,
  onClose,
  anchorEl,
  toggleModal,
  handleCloseMenu,
  logout,
  name,
  email,
  classes,
  testid
}) => {
  const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
      borderRadius: 8,
      minWidth: 240
    },
    borderBottom: `${colors.surface} solid 1px`
  });
  const StyledMenuItem = styled(MenuItem)({
    height: 'auto',
    justifyContent: 'center',
    minWidth: '100%',
    padding: '5px',
    paddingTop: '10px'
  });
  const TopMenuItem = styled("div")({
    padding: '30px',
    paddingTop: '20px',
    textAlign: 'center'
  });
  return /*#__PURE__*/React.createElement(StyledMenu, {
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    disableAutoFocusItem: true,
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottom: `${colors.surface} solid 1px`
    }
  }, /*#__PURE__*/React.createElement(TopMenuItem, null, /*#__PURE__*/React.createElement(Avatar, {
    name: name,
    size: "55",
    textSizeRatio: 2.2,
    round: false,
    color: colors.skyBlue,
    style: {
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testid: testid,
    align: 'center',
    medium: true,
    bold: true,
    display: "block"
  }, name), /*#__PURE__*/React.createElement(Text, {
    align: 'center',
    medium: true,
    light: true,
    display: "block"
  }, email))), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: () => toggleModal('showSettingsModal')
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Settings")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block"
  }, "Resources")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    medium: true,
    display: "block"
  }, "Contact Support")), /*#__PURE__*/React.createElement(StyledMenuItem, {
    onClick: logout
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.red,
    align: "center",
    medium: true,
    display: "block"
  }, "Logout")));
};
export default MasterMetaMenu;